import { useContext, useState } from 'react'

import { Box, Button, Icon, Text } from '@fairfashion/design-system'

import { QRCodeDetailsContext } from '../../qrcode-details.context'
import * as QRCodeDetailsStyles from '../../qrcode-details.styles'
import { InformationColumn } from '../InformationColumn/information-colum.comp'
import { QRCodeDetailsFeedstockFormModal } from '../QRCodeDetailsFeedstockFormModal/qrcode-details-feedstock-form-modal.comp'
import { QRCodeDetailsPartFormModal } from '../QRCodeDetailsPartFormModal/qrcode-details-part-form-modal.comp'

import * as Styles from './qrcode-details-parts.styles'

export const QRCodeDetailsParts = () => {
  const [partFormModalOpen, setPartFormModalOpen] = useState(false)
  const [feedstockFormModalOpen, setFeedstockFormModalOpen] = useState(false)

  const [selectedPartIndex, setSelectedPartIndex] = useState<number>()
  const [selectedFeedstockIndex, setSelectedFeedstockIndex] = useState<number>()

  const { qrcode, actions } = useContext(QRCodeDetailsContext)

  const handleEditPart = (partIndex: number) => {
    setSelectedPartIndex(partIndex)
    setPartFormModalOpen(true)
  }

  const handleClosePartFormModal = () => {
    setPartFormModalOpen(false)
    setSelectedPartIndex(undefined)
  }

  const handleCreateFeedstock = (partIndex: number) => {
    setSelectedPartIndex(partIndex)
    setFeedstockFormModalOpen(true)
  }

  const handleEditFeedstock = (partIndex: number, feedstockIndex: number) => {
    setSelectedPartIndex(partIndex)
    setSelectedFeedstockIndex(feedstockIndex)
    setFeedstockFormModalOpen(true)
  }

  const handleCloseFeedstockFormModal = () => {
    setFeedstockFormModalOpen(false)
    setSelectedPartIndex(undefined)
    setSelectedFeedstockIndex(undefined)
  }

  const handleDeletePart = (partId: string) => {
    actions.deleteFinishedItemProfilePart(partId)
  }

  const handleDeleteFeedstock = (feedstockId: string) => {
    actions.deleteFeedstockItemProfile(feedstockId)
  }

  return (
    <QRCodeDetailsStyles.Card direction="column" gap={2}>
      <Box width="100%" justifyContent="space-between" alignItems="center">
        <Text fontWeight={500}>Partes do produto</Text>
        <Button padding="10px 14px" onClick={() => setPartFormModalOpen(true)}>
          <Icon name="add" color="white" />
          <Text color="white" size="small" fontWeight={500}>
            Adicionar parte
          </Text>
        </Button>
      </Box>

      {qrcode?.finishedItemProfile?.parts?.map((part, index) => (
        <Styles.Table key={`part-${part.id}`}>
          <Styles.HeaderRow justifyContent="space-between">
            <Box width="70%" flexWrap="wrap" gap={2} alignItems="center">
              <InformationColumn label="Parte" value={`#${index + 1}`} />
              <InformationColumn label="Código" value={part.code} />
              <InformationColumn label="Nome" value={part.name} />
              <Box flex={1} />
              <Box flex={1} />
            </Box>
            <Box gap={2}>
              <Button
                padding="0"
                variant="text"
                onClick={() => handleEditPart(index)}
              >
                <Icon name="edit" color="grey_3" size={24} />
              </Button>
              <Button
                padding="0"
                variant="text"
                onClick={() => handleDeletePart(part.id)}
              >
                <Icon name="delete_bin" color="grey_3" size={24} />
              </Button>
            </Box>
          </Styles.HeaderRow>
          {part.feedstocks?.map((feedstock, indexF) => (
            <Styles.Row
              justifyContent="space-between"
              key={`feedstock-${feedstock.id}`}
            >
              <Box flexWrap="wrap" gap={2} alignItems="center" width="70%">
                <InformationColumn
                  label="Matéria-prima"
                  value={`${indexF + 1}`}
                />
                <InformationColumn label="Código" value={feedstock.code} />
                <InformationColumn label="Nome" value={feedstock.name} />
                <InformationColumn
                  label="Descrição"
                  value={feedstock.description}
                />
                <InformationColumn
                  label="Composição"
                  value={`${feedstock.composition}%`}
                />
              </Box>
              <Box gap={2}>
                <Button
                  padding="0"
                  variant="text"
                  onClick={() => handleEditFeedstock(index, indexF)}
                >
                  <Icon name="edit" color="grey_3" size={24} />
                </Button>
                <Button
                  padding="0"
                  variant="text"
                  onClick={() => handleDeleteFeedstock(feedstock.id)}
                >
                  <Icon name="delete_bin" color="grey_3" size={24} />
                </Button>
              </Box>
            </Styles.Row>
          ))}
          <Styles.Row justifyContent="center" alignItems="center">
            <Button
              variant="text"
              padding="0"
              onClick={() => handleCreateFeedstock(index)}
            >
              <Box gap={1} alignItems="center">
                <Text color="grey_3">Adicionar Matéria-prima</Text>
                <Icon name="add" color="grey_3" size={24} />
              </Box>
            </Button>
          </Styles.Row>
        </Styles.Table>
      ))}

      <QRCodeDetailsPartFormModal
        open={partFormModalOpen}
        onClose={handleClosePartFormModal}
        defaultValues={
          selectedPartIndex !== undefined
            ? qrcode?.finishedItemProfile?.parts?.[selectedPartIndex]
            : undefined
        }
        index={selectedPartIndex}
      />

      <QRCodeDetailsFeedstockFormModal
        open={feedstockFormModalOpen}
        onClose={handleCloseFeedstockFormModal}
        partId={
          selectedPartIndex !== undefined
            ? qrcode?.finishedItemProfile?.parts?.[selectedPartIndex]?.id
            : undefined
        }
        defaultValues={
          selectedPartIndex !== undefined &&
          selectedFeedstockIndex !== undefined
            ? qrcode?.finishedItemProfile?.parts?.[selectedPartIndex]
                ?.feedstocks?.[selectedFeedstockIndex]
            : undefined
        }
      />
    </QRCodeDetailsStyles.Card>
  )
}
